export default __webpack_public_path__ + "static/media/newlogo.0844a570.png";